<template>
  <div class="productIntro">
    <p class="heading-btm-w3ls"></p>
    <div class="productIntro-nav">
      <div
        v-for="(item, i) in typeList"
        @click="handleChangeCategory(item, i)"
        :class="item.selected ? 'select' : ' '"
      >{{ item.categoryName }}</div>
    </div>
    <div v-if="categoryId != 21" class="productIntro-list">
      <div v-for="(item, i) in productList">
        <div class="productIntro-list-item">
          <img :src="application.imageHost + item.logoPath" />
          <div class="productIntro-list-item-right">
            <div class="productIntro-list-item-right-name">{{ item.name }}</div>
            <div class="productIntro-list-item-right-pro" v-html="item.des"></div>
            <!-- <div class="productIntro-list-item-right-sene">适用场景：</div>
            <div class="sene-content">
              <div
                class="sene-content-item"
                v-for="(sceneItem, i) in item.sceneList"
              >
                <img src="../../images/choose.png" />
                <span>{{ sceneItem.title }}</span>
              </div>
            </div>-->
            <!--            <div class="product-cont">-->
            <!--              <div class="productIntro-list-item-right-sene">-->
            <!--                产品内容：-->
            <!--              </div>-->
            <!--              <div class="productIntro-list-item-right-pro">-->
            <!--                {{item.sumDes}}-->
            <!--              </div>-->
            <!--            </div>-->
            <!-- <div class="product-pro">
              <div class="productIntro-list-item-right-sene">产品优势：</div>
              <div class="product-advList">
                <div
                  class="product-advList-item"
                  v-for="(adverItem, i) in item.advantageList"
                >
                  <img :src="application.imageHost + adverItem.signPath" />
                  <span>{{ adverItem.content }}</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
        <div class="product-phone">
          <div class="product-advList">
            <div class="product-advList-item" v-for="(adverItem, i) in item.advantageList">
              <img :src="application.imageHost + adverItem.signPath" />
              <span>{{ adverItem.content }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="categoryId == 21"
      class="productIntro-list"
      style="display:flex;flex-wrap:wrap;    justify-content:space-between;    width: 80%; margin-left:10%"
    >
      <div v-for="(item, i) in productList">
        <div class="productIntro-list-item">
          <img :src="application.imageHost + item.logoPath" />
        </div>
      </div>
    </div>
  </div>
</template>
<style src="./productIntro.css" scoped></style>
<script>
import mixins from "../../common/mixin";
import application from "../../common/application";
export default {
  name: "productIntro",
  mixins: [mixins],
  data: () => ({
    typeList: [],
    application: application,
    categoryName: "",
    categoryId: "",
    productList: [],
    count: 0,
  }),
  props: {
    pageSize: {
      type: Number,
      required: true,
    },
    pageIndex: {
      type: Number,
      required: false,
    },
    // count:{
    //     type:Number,
    //     required:false
    // },
    pageDefaltIndex: {
      type: Number,
      required: true,
    },
  },
  watch: {
    //监听value的变化，进行相应的操作即可
    pageIndex: function (pageIndex) {
      //a是value的新值，b是旧值
      this.pageIndex = pageIndex;
      this.handleCategaryProductList();

      //
    },
    $route: {
      handler() {
        this.handleProductTypeList();
      },
      deep: true,
    },
  },
  created() {
    this.handleProductTypeList();
  },

  methods: {
    //产品分类
    handleProductTypeList() {
      this.request({
        url: "/web/category/list",
        data: {
          id: "product",
        },
        success: (response) => {
          console.log(response.data);
          this.typeList = response.data;
          let type = 0;
          if (this.$route.query.type) {
            type = this.$route.query.type;
          }
          this.categoryName = this.typeList[type]
            ? this.typeList[type].categoryName
            : "";

          this.categoryId = this.typeList[type]
            ? this.typeList[type].categoryId
            : "";
          for (var i = 0; i < this.typeList.length; i++) {
            this.typeList[i].selected = false;
          }
          this.typeList[type].selected = true;
          this.handleProductList();
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
    // 分类初始产品列表
    handleProductList() {
      this.request({
        url: "/web/product/list",
        data: {
          pageIndex: this.pageDefaltIndex,
          pageSize: this.pageSize,
          categoryId: this.categoryId,
          dictCode: "product",
        },
        success: (response) => {
          console.log(response.data);
          this.productList = response.data.records;
          this.count = response.data.total;
          this.$emit("update", this.count, this.pageDefaltIndex);
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
    // 分类动态产品列表
    handleCategaryProductList() {
      this.request({
        url: "/web/product/list",
        data: {
          pageIndex: this.pageDefaltIndex,
          pageSize: this.pageSize,
          categoryId: this.categoryId,
          dictCode: "product",
        },
        success: (response) => {
          console.log(response.data);
          this.productList = response.data.records;
          this.count = response.data.total;
          this.$emit("update", this.count, this.pageIndex);
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
    handleChangeCategory(item, index) {
      this.categoryName = item.categoryName;
      this.categoryId = item.categoryId;
      for (var i = 0; i < this.typeList.length; i++) {
        this.typeList[i].selected = false;
      }
      this.typeList[index].selected = true;
      this.handleProductList();
    },
  },

  // //查找产品
  // handleSearchPro(categoryName){
  //
  // }
  // }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/productIntro/productIntro.vue